export default "__VITE_ASSET__C1$FmA8u__"